<template>
  <v-flex xs12>
    <data-source-table
      itemController="prospect"
      itemIdentifyField="name"
      :headers="headers"
      :options.sync="options"
      :selected-items.sync="selectedItems"
      :get-data-hook="getDataHook"
      :add-item-hook="addItemHook"
      ref="dataSourceRef"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog
            v-model="createProspectDialog.isOpened"
            width="700"
            @click:outside="closeCreateProspectDialog"
            @keydown.esc="closeCreateProspectDialog"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                fab
                small
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <slot>
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        dark
                      >
                        mdi-plus
                      </v-icon>
                    </slot>
                  </template>
                  create new prospect
                </v-tooltip>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Prospect</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="createProspectDialog.prospect.name"
                        label="Prospect name"
                        :rules="requiredRule"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="createProspectDialog.prospect.full_name"
                        label="Prospect full name"
                        :rules="requiredRule"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      :cols="6"
                    >
                      <v-menu
                        ref="menu"
                        v-model="createProspectDialog.isOpenedMenuStartDate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="formatedDate(createProspectDialog.prospect.start_date)"
                            label="Start date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="requiredRule"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="createProspectDialog.prospect.start_date"
                          @input="createProspectDialog.isOpenedMenuStartDate = false"
                          no-title
                          scrollable
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      :cols="6"
                    >
                      <v-menu
                        ref="menu"
                        v-model="createProspectDialog.isOpenedMenuEndDate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="formatedDate(createProspectDialog.prospect.end_date)"
                            label="End date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="requiredRule"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="createProspectDialog.prospect.end_date"
                          @input="createProspectDialog.isOpenedMenuEndDate = false"
                          no-title
                          scrollable
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-if="!createProspectDialog.prospect.airline_icao"
                        v-model="createProspectDialog.prospect.airports_iata"
                        label="Airports: Code IATA"
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="!createProspectDialog.prospect.airline_icao
                      && !createProspectDialog.prospect.airports_iata"
                  >
                    <v-col>or</v-col>
                  </v-row>
                  <v-row
                    v-if="!createProspectDialog.prospect.airports_iata"
                  >
                    <v-col>
                      <v-text-field
                        v-model="createProspectDialog.prospect.airline_icao"
                        label="Airline: Code ICAO"
                        clearable
                      />
                      <v-alert
                        type="warning"
                        outlined
                      >
                        We have completed the transition to the new OAG_snowflake provider.
                        Import rules have been changed!<br />
                        - to get data for a specific airline enter airline code,
                        do not use hubs<br />
                        - you can use hubs only to get data for a specific airline AND
                        specific airports
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="!createProspectDialog.prospect.airports_iata"
                  >
                    <v-col>
                      <v-text-field
                        v-model="createProspectDialog.prospect.hubs_iata"
                        label="Hubs: Code IATA"
                        clearable
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeCreateProspectDialog"
                >
                  Cancel
                </v-btn>
                <v-btn
                  @click="saveNew"
                  color="blue darken-1"
                  text
                  :disabled="!isNewProspectHasEnoughData"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="updateProspectDialog.isOpened"
            width="400"
            @click:outside="closeUpdateProspectDialog"
            @keydown.esc="closeUpdateProspectDialog"
          >
            <v-card>
              <v-card-title>
                <span class="headline">Prospect {{ updateProspectDialog.prospect.name }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="6"
                    >
                      <div>Prospect name:</div>
                      <div class="font-weight-bold">
                        {{ updateProspectDialog.prospect.name }}
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <div>Prospect full name:</div>
                      <div class="font-weight-bold">
                        {{ updateProspectDialog.prospect.full_name }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="updateProspectDialog.prospect.airports_iata.airports"
                  >
                    <v-col>
                      <div>Airports code IATA: </div>
                      <div class="font-weight-bold">
                        {{
                          updateProspectDialog.prospect.airports_iata.airports
                          && Array.isArray(updateProspectDialog.prospect.airports_iata.airports)
                            ? updateProspectDialog.prospect.airports_iata.airports.join(', ')
                            : ''
                        }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="updateProspectDialog.prospect.airline_icao"
                  >
                    <v-col>
                      <div>Airline code ICAO: </div>
                      <div class="font-weight-bold">
                        {{ updateProspectDialog.prospect.airline_icao }}
                      </div>
                    </v-col>
                    <v-col>
                      <div
              v-if="isNotEmptyOptionsArray(updateProspectDialog.prospect.airports_iata, 'hubs')"
                      >Hubs code IATA: </div>
                      <div
              v-if="isNotEmptyOptionsArray(updateProspectDialog.prospect.airports_iata, 'hubs')"
                        class="font-weight-bold">
                        {{ updateProspectDialog.prospect.airports_iata.hubs.join(', ') }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      :cols="6"
                    >
                      <v-menu
                        ref="menu"
                        v-model="updateProspectDialog.isOpenedMenuStartDate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="formatedDate(updateProspectDialog.prospect.start_date)"
                            label="Start date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="updateProspectDialog.prospect.start_date"
                          @input="updateProspectDialog.isOpenedMenuStartDate = false"
                          no-title
                          scrollable
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      :cols="6"
                    >
                      <v-menu
                        ref="menu"
                        v-model="updateProspectDialog.isOpenedMenuEndDate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="formatedDate(updateProspectDialog.prospect.end_date)"
                            label="End date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="updateProspectDialog.prospect.end_date"
                          @input="updateProspectDialog.isOpenedMenuEndDate = false"
                          no-title
                          scrollable
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeUpdateProspectDialog"
                >
                  Cancel
                </v-btn>
                <v-btn
                  @click="runNewApiRequest"
                  color="blue darken-1"
                  text
                >
                  Update
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-spacer/>
          <v-progress-circular
            v-if="requestTimer.isRequestActive"
            size="30"
            indeterminate
          />

          <v-btn
              class="mx-2" color="blue darken-1"
              outlined small
              @click="$refs.dataSourceRef ? $refs.dataSourceRef.openDialogSelectColumns() : false"
          >
            Select columns
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.name="{item}">
        {{ item.name }}
        <v-tooltip
          v-if="item.status === $constants.API_STATUS.DONE"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              :to="`prospect/${item.id}`" target="_blank"
              icon
              small
            >
              <v-icon color="orange" dense>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          show on page
        </v-tooltip>
      </template>

      <template v-slot:item.date="{ item }">
        {{ formatedDate(item.start_date) }} - {{ formatedDate(item.end_date) }}
      </template>

      <template v-slot:item.status="{ item }">
        <v-row>
          <v-col align-self="center">
            <StatusMarker
              :status="item.status"
              :message="item.error"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.airports="{ item }">
        {{ item.airports_iata.airports ? item.airports_iata.airports.join(', ') : '' }}
      </template>

      <template v-slot:item.airline="{ item }">
        {{ item.airline_icao }}
        <div
          v-if="isNotEmptyOptionsArray(item.airports_iata, 'hubs')"
        >
        with hubs: {{ item.airports_iata.hubs.join(', ') }}
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-row>
          <v-col
            align-self="center"
            :cols="6"
          >
            <v-tooltip
              v-if="isStatusDone(item.status)"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-on="on"
                  v-bind="attrs"
                  @click="openUpdateDialog(item)"
                >
                  <v-icon
                    color="blue"
                  >
                    mdi-file-arrow-up-down
                  </v-icon>
                </v-btn>
              </template>
              update
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
    </data-source-table>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import StatusMarker from '../components/StatusMarker.vue';
import DataSourceTable from '../components/DataSource/DataTable.vue';

export default {
  name: 'Prospect',
  components: {
    DataSourceTable,
    StatusMarker,
  },

  data: () => ({
    selectedItems: [],
    options: { filters: { } },
    clonedItem: {},

    createProspectDialog: {
      isOpened: false,
      isOpenedMenuStartDate: false,
      isOpenedMenuEndDate: false,
      prospect: {
        name: '',
        full_ame: '',
        start_date: '',
        end_date: '',
        airports_iata: '',
        airline_icao: '',
        hubs_iata: '',
      },
    },

    updateProspectDialog: {
      isOpened: false,
      isOpenedMenuStartDate: false,
      isOpenedMenuEndDate: false,
      prospect: {
        id: null,
        name: '',
        full_name: '',
        start_date: '',
        end_date: '',
        airports_iata: {},
        airline_icao: '',
        hubs_iata: [],
      },
    },

    headers: [
      {
        text: 'id', value: 'id', width: '120px',
      },
      {
        text: 'name', value: 'name', width: '300px',
      },
      {
        text: 'full name', value: 'full_name', width: '300px', edit: { type: 'text', emptyPlaceholder: true },
      },
      {
        text: 'airports IATA', value: 'airports', width: '300px', sortable: false,
      },
      {
        text: 'airline ICAO', value: 'airline', width: '150px', sortable: false,
      },
      {
        text: 'date', value: 'date', width: '200px', sortable: false,
      },
      {
        text: 'status', value: 'status', width: '150px',
      },
      {
        text: '', value: 'actions', width: '80px', sortable: false,
      },
      {
        text: '', value: 'deleteItem', width: '80px', sortable: false,
      },
    ],

    requiredRule: [
      (v) => !!v || 'Required',
    ],

    requestTimer: {
      isRequestActive: false,
      instance: null,
      prospectIds: [],
    },
  }),

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    getDataHook() {
      this.runCheckStatusesRequests();
    },

    saveNew() {
      if (
        !this.createProspectDialog.prospect.airports_iata
        && (
          !this.createProspectDialog.prospect.airline_icao
        )
      ) {
        this.setSnack({
          color: 'orange',
          text: 'Please fill Airports IATA or Airline ICAO',
        });

        return false;
      }

      this.createProspectDialog.isOpened = false;

      return this.$refs.dataSourceRef.saveNew(
        {
          ...this.createProspectDialog.prospect,
          ...{
            airports_iata: this.createProspectDialog.prospect.airports_iata
              ? this.createProspectDialog.prospect.airports_iata
                .split(',')
                .map((el) => el.trim())
                .filter((el) => el.length)
              : [],
          },
          ...{
            hubs_iata: this.createProspectDialog.prospect.hubs_iata
              ? this.createProspectDialog.prospect.hubs_iata
                .split(',')
                .map((el) => el.trim())
                .filter((el) => el.length)
              : [],
          },
        },
      ).finally(() => {
        this.resetCreateProspectDialog();
      });
    },

    addItemHook() {
      this.runCheckStatusesRequests();
    },

    runNewApiRequest() {
      this.$requestHelpers.post(
        'api/admin/prospect/runRouteMapStatistics',
        {
          id: this.updateProspectDialog.prospect.id,
          start_date: this.updateProspectDialog.prospect.start_date,
          end_date: this.updateProspectDialog.prospect.end_date,
        },
      )
        .then((response) => {
          this.$refs.dataSourceRef.updateData(response.data.result);
        })
        .finally(() => {
          this.closeUpdateProspectDialog();
          this.runCheckStatusesRequests();
        });
    },

    openUpdateDialog(item) {
      Object.assign(this.updateProspectDialog.prospect, item);

      this.updateProspectDialog.isOpened = true;
    },

    resetUpdateProspectDialog() {
      Object.assign(
        this.updateProspectDialog.prospect,
        {
          id: null,
          name: '',
          full_name: '',
          start_date: '',
          end_date: '',
          airports_iata: {},
          airline_icao: '',
        },
      );
    },

    closeUpdateProspectDialog() {
      this.updateProspectDialog.isOpened = false;

      this.resetUpdateProspectDialog();
    },

    resetCreateProspectDialog() {
      Object.assign(
        this.createProspectDialog.prospect,
        {
          name: '',
          full_name: '',
          start_date: '',
          end_date: '',
          airports_iata: '',
          airline_icao: '',
          hubs_iata: '',
        },
      );
    },

    closeCreateProspectDialog() {
      this.createProspectDialog.isOpened = false;
      this.resetCreateProspectDialog();
    },

    runCheckStatusesRequests() {
      if (this.requestTimer.instance) {
        return true;
      }

      this.collectProspectsInProgress();

      if (!this.requestTimer.prospectIds.length) {
        return true;
      }

      this.requestTimer.instance = setTimeout(() => {
        this.requestTimer.isRequestActive = true;
        this.axios.post(
          'api/admin/prospect/checkProspectsStatuses',
          {
            ids: this.requestTimer.prospectIds,
          },
        ).then((response) => {
          response.data.result.forEach((item) => {
            this.$refs.dataSourceRef.updateData(item);
          });
          clearTimeout(this.requestTimer.instance);
          this.requestTimer.instance = null;

          this.runCheckStatusesRequests();
        }).finally(() => { this.requestTimer.isRequestActive = false; });
      }, 10000);

      return true;
    },

    collectProspectsInProgress() {
      this.requestTimer.prospectIds = this.$refs.dataSourceRef.allItems()
        .filter((el) => el.status === this.$constants.API_STATUS.IN_PROGRESS)
        .map((el) => el.id);
    },

    isNotEmptyOptionsArray(parentElement, childArrayElement) {
      return parentElement
        && parentElement[childArrayElement]
        && Array.isArray(parentElement[childArrayElement])
        && parentElement[childArrayElement].length;
    },
  },

  computed: {
    formatedDate() {
      return (dateString) => {
        if (!dateString) {
          return '';
        }

        const dateParts = dateString.split('-');

        return `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
      };
    },

    isNewProspectHasEnoughData() {
      return this.createProspectDialog.prospect.name
        && this.createProspectDialog.prospect.start_date
        && this.createProspectDialog.prospect.end_date
        && (
          this.createProspectDialog.prospect.airports_iata
          || this.createProspectDialog.prospect.airline_icao
        );
    },

    isStatusDone() {
      return (status) => status === this.$constants.API_STATUS.DONE;
    },
  },

  deactivated() {
    clearTimeout(this.requestTimer.instance);
    this.requestTimer.instance = null;

    this.$destroy();
  },
};
</script>

<style scoped>

</style>
